import type { Page } from '../../types';

const roleSelection: Page[] = [
  {
    pageType: 'question',
    title: 'Role Selection',
    name: 'role-selection',
    hideSubTitle: true,
    titleClassName: 'gdad-tight-title',
    description:
      '<p class="govuk-body">Role and skill definitions will open in the relevant profession framework guidance.</p>\n<p class="govuk-body"></p>\n<p class="govuk-body"></p>',
    questions: [
      {
        questionType: 'select',
        title: 'What is your grade?',
        name: 'grade',
        hintOption: 'Select an option',
        options: [
          'Grade 6',
          'Grade 7',
          'Senior Executive Officer',
          'Higher Executive Officer',
        ],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'gdadRoleSelectionInput',
        title: 'Select your role',
        name: 'role',
        lookupQuestion: 'grade',
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default roleSelection;
